import { CrewWidget } from '@/components/events/detail/tabs/flows/crew/crew-widget';

export default function Crew() {
  return <CrewWidget variant="event" />;
}
